export default "__VITE_ASSET__BpzpuqsM__"